import { combineReducers } from 'redux';
import { handleActions } from 'redux-actions';
import * as Actions from '../actions/AdminListRegisterLiveStream';

const getAllOrderLivestreamReducer = handleActions({
    [Actions.getAllOrderLivestreamRequested]: (state) => ({
        ...state,
        isFetching: true,
    }),
    [Actions.getAllOrderLivestreamRequestedReceived]: (state, action) => ({
        ...state,
        isFetching: false,
        data: action.payload,
    }),
    [Actions.getAllOrderLivestreamRequestedReceivedFailure]: (state, action) => ({
        ...state,
        isFetching: false,
        errors: action.payload.errors,
    }),
    [Actions.clearOrderLivestreamData]: () => ({
        isFetching: false,
        data: {},
        errors: {},
    }),
}, {
    isFetching: false,
    data: {},
    errors: {},
});

const getDetailOrderLivestreamReducer = handleActions({
    [Actions.getDetailOrderLivestreamRequested]: (state) => ({
        ...state,
        isFetching: true,
    }),
    [Actions.getDetailOrderLivestreamRequestedReceived]: (state, action) => ({
        ...state,
        isFetching: false,
        data: action.payload,
    }),
    [Actions.getDetailOrderLivestreamRequestedReceivedFailure]: (state, action) => ({
        ...state,
        isFetching: false,
        errors: action.payload.errors,
    }),
    [Actions.clearDetailOrderLivestreamData]: () => ({
        isFetching: false,
        data: {},
        errors: {},
    }),
}, {
    isFetching: false,
    data: {},
    errors: {},
});

const updateStatusTransactionReducer = handleActions({
    [Actions.updateStatusLivestreamRequested]: (state) => ({
        ...state,
        isFetching: true,
        isSuccess: false,
    }),
    [Actions.updateStatusLivestreamRequestedReceived]: (state) => ({
        ...state,
        isFetching: false,
        isSuccess: true,
    }),
    [Actions.updateStatusLivestreamRequestedReceivedFailure]: (state, action) => ({
        ...state,
        isFetching: false,
        isSuccess: false,
        errors: action.payload.errors,
    }),
    [Actions.clearStatusLivestream]: () => ({
        isFetching: false,
        isSuccess: false,
        errors: {},
    }),
}, {
    isFetching: false,
    isSuccess: false,
    errors: {},
});

const resentMailOrderReducer = handleActions({
    [Actions.resentMailLivestreamRequested]: (state) => ({
        ...state,
        isFetching: true,
        isSuccess: false,
    }),
    [Actions.resentMailLivestreamRequestedReceived]: (state) => ({
        ...state,
        isFetching: false,
        isSuccess: true,
    }),
    [Actions.resentMailLivestreamRequestedReceivedFailure]: (state, action) => ({
        ...state,
        isFetching: false,
        isSuccess: false,
        errors: action.payload.errors,
    }),
    [Actions.clearMailLivestream]: () => ({
        isFetching: false,
        isSuccess: false,
        errors: {},
    }),
}, {
    isFetching: false,
    isSuccess: false,
    errors: {},
});

export default combineReducers({
    getAllOrder: getAllOrderLivestreamReducer,
    getDetailOrder: getDetailOrderLivestreamReducer,
    updateStatus: updateStatusTransactionReducer,
    resentMail: resentMailOrderReducer,
});
